/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // tooltip & popover init
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="popover"]').popover();
        // call product menu
        $('.call-product').on('click', function(e){
          e.preventDefault();
          $('.product-menu').toggleClass('is-onstage');
          $('body').toggleClass('is-locked');
          $('.flexslider').flexslider('pause');
        });
        // close product menu
        $('.product-menu__close').on('click', function(){
          $('.flexslider').flexslider('play');
        });
        // load js first and show reveal all content
        $(window).load(function() {  document.getElementById("hideAll").style.display = "none"; });
      }
    },
    // Home page
    'home': {
      init: function() {
      },
      finalize: function() {
        // kenburn slider
        // $(".slide-image").each(function(){
        //   var bg = $(this).data("bg");
        //   var pos = $(this).data("kenburn-start");
          
        //   $(this).css({
        //     "background-image":"url("+bg+")",
        //     "transform-origin": pos
        //   });
        // });
        $(".flexslider").flexslider({
          animation: "slide",
          slideshow: true,
          slideshowSpeed : 4000,
          animationSpeed : 1000,
          directionNav: false,
          manualControls: ".indicator__nav li",
          start: function(){
            $('.slide-image__text').removeClass('is-show');
            $('.flex-active-slide .slide-image__text').addClass('is-show');
          },
          before: function(slider){
            // $('.slide-image__text').removeClass('is-show');
            var animateSlide = slider.slides.eq(slider.animatingTo);
            $('.slide-image__text').removeClass('is-show');
            $(animateSlide).find('.slide-image__text').addClass('is-show');
          }
        });
        //show product on indicator
        $('.indicator-item').on('click', function(){
          if(!($(this).hasClass('is-active'))){
            $('.indicator-item.is-active').removeClass('is-active');
          }
          $(this).toggleClass('is-active');
        });
        // go to product page
        $('.indicator-item__detail__link').on('click', function(){
          window.location.href = $(this).attr('href');
        });
      }
    },
    // About us page, note the change from about-us to about_us.
    'single': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        // product details
        $('.more-toggle__link').on('click', function(e){
          e.preventDefault();
          $('.summary').toggleClass('is-full');
          $('.woocommerce-product-gallery').toggleClass('is-full');
        });
      }
    },
    'about': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        // product details
        $(".about-slider").flexslider({
          slideshow: true,
          slideshowSpeed : 5000,
          animationSpeed : 1000,
          directionNav: false,
          controlNav: false,
        });
      }
    },
    'support': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        // show store
        $('.stockist__title').on('click', function(e){
          e.preventDefault();
          $('.stockist.is-active').removeClass('is-active');
          $(this).parent('.stockist').toggleClass('is-active');
        });
        // filter product
        $('.retail-checker__filter a').on('click', function(e){
          e.preventDefault();
          $('.extra').toggleClass('is-active');
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
